module.exports = __webpack_public_path__ + "static/media/24.9bf1edfc.svg";